module.exports = __webpack_public_path__ + "static/blog-16-79360fbd89991f1b462b170eee7c67fb.png";